<!--
 * @Author: error: error: git config user.name & please set dead value or install git && error: git config user.email & please set dead value or install git & please set dead value or install git
 * @Date: 2022-07-18 14:42:18
 * @LastEditors: error: error: git config user.name & please set dead value or install git && error: git config user.email & please set dead value or install git & please set dead value or install git
 * @LastEditTime: 2023-04-18 16:46:42
 * @FilePath: \ioc_base\src\modules\cameraList\components\serviceData.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<!-- 编辑设备详情弹框 -->
<template>
  <div class="dialog-app-panel" :class="dataDialog ? 'dialog-show' : ''">
    <app-panel :isExpand="dataDialog" title="运行数据" @cancel="dataDialog = false">
      <!-- <el-dialog title="运行数据"
             :visible.sync="dataDialog"
             v-dialogDrag> -->
      <ioc-table
        ref="devTab"
        :data="tableData"
        :option="option"
        :page="page"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
      >
      </ioc-table>
      <span slot="footer" class="dialog-footer">
        <el-button type="info" @click="dataDialog = false">关闭</el-button>
      </span>
      <!-- </el-dialog> -->
    </app-panel>
  </div>
</template>
<script>
import { api } from "../api";
import appPanel from "@src/components/business/app-panel/index.vue";
import tableOption from "../const/dataTable";
export default {
  props: {
    deviceType: {
      type: String,
      default: null,
    },
  },
  components: {
    appPanel,
  },
  data() {
    return {
      dataDialog: false,
      deviceId: "",
      // 分页属性设置
      page: {
        currentPage: 1,
        total: 0,
        pageSize: this.$utils.Cache.get("CURRENT_PAGESIZE") || 10,
      },
      option: tableOption(this),
      tableData: [
        // {
        //   "thirdDeviceId": "",			//唯一标识号
        //   "deviceMark": "", //系统类型
        //   "mac": "", //系统地址
        //   "typeMark": "", //系统标志
        //   "loop": "", //回路
        //   "subDeviceMark": "", //部件类型，枚举：SENU094
        //   "subDeviceMac": "", //部件地址
        //   "subDeviceDesc": "", //部件说明
        //   "recordTime": "2020-05-06", //时间
        //   "status": "", //运行状态
        //   "data": ""					//上报码流
        // }
      ],
    };
  },
  mounted() {},
  methods: {
    open(deviceId) {
      this.dataDialog = true;
      this.deviceId = deviceId;
      this.getList();
    },
    //获取运行数据列表
    getList() {
      console.log(this.page);
      const params = {
        // thirdDeviceId: thirdDeviceId,
        deviceId: this.deviceId,
        pageNum: this.page.currentPage,
        pageSize: this.page.pageSize,
      };
      this.$fetch(api.queryFirefightOperationList, params).then((response) => {
        if (!response.success) {
          this.$message.error(response.msgContent);
          return;
        }
        this.tableData = response.returnObj
          ? Object.freeze([...response.returnObj.list])
          : [];
        this.page.total = response.returnObj ? response.returnObj.total : 0;
      });
    },
    handleCurrentChange(val) {
      this.page.currentPage = val;
      this.getList();
    },
    handleSizeChange(val) {
      this.page.currentPage = 1;
      this.page.pageSize = val;
      this.getList();
    },
  },
};
</script>
<style lang="scss"></style>
